import React, { useEffect } from 'react'

import posthog from 'posthog-js'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-tooltip/dist/react-tooltip.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

//routes
import AppRoutes from '@src/AppRoutes'
import { AuthProvider } from '@src/providers/AuthProvider'
import SolanaModalProvider from '@src/providers/SolanaModalProvider'
import TronModalProvider from '@src/providers/TronModalProvider'
import { Web3ModalProvider } from '@src/providers/Web3ModalProvider'
import { logger } from '@src/utils/logger'

const ASCII_ART = `
███╗   ███╗ █████╗  ██████╗██╗  ██╗
████╗ ████║██╔══██╗██╔════╝██║  ██║
██╔████╔██║███████║██║     ███████║
██║╚██╔╝██║██╔══██║██║     ██╔══██║
██║ ╚═╝ ██║██║  ██║╚██████╗██║  ██║
╚═╝     ╚═╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝
                                    
███████╗██╗  ██╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
██╔════╝╚██╗██╔╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
█████╗   ╚███╔╝ ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗  
██╔══╝   ██╔██╗ ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝  
███████╗██╔╝ ██╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
╚══════╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝
`

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { refetchOnMount: false, refetchOnWindowFocus: false },
    },
})

const App: React.FC = () => {
    useEffect(() => {
        console.log(ASCII_ART)
        console.log('Welcome to Mach.Exchange! 🚀')
    }, [])

    try {
        posthog.init('phc_j0R37FbhaZfrYpkak4NvVfdKrNRgKTtV5AbP3y7RCCe', {
            api_host: 'https://us.i.posthog.com',
            person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        })
        logger.info('[posthog] initialized')
    } catch (error) {
        logger.error('[posthog] error:', error)
    }

    return (
        <QueryClientProvider client={queryClient}>
            <SolanaModalProvider>
                <TronModalProvider>
                    <Web3ModalProvider>
                        <AuthProvider>
                            <>
                                <AppRoutes />
                            </>
                        </AuthProvider>
                    </Web3ModalProvider>
                </TronModalProvider>
            </SolanaModalProvider>
        </QueryClientProvider>
    )
}

export default App
